import { forwardRef } from "react";
import { getObjValueFromPath } from "../../utils";
import { FormControl, FormErrorMessage, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import EsgFormLabel from "./EsgFormLabel";

function MoneyFormInput(
  { label, name, id = name, sign, errors, controlProps, maxInlineSize, ...rest }, ref
) {
  const error = getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={maxInlineSize ? maxInlineSize : { base: "full", lg: "xs" }}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel
          htmlFor={id}
        >
          {label}
        </EsgFormLabel>
      )}
      <InputGroup>
        <InputLeftAddon marginBlockStart={1} children={sign} />
        <Input backgroundColor="white"
               id={id}
               name={name}
               onWheel={e => e.target.blur()}
               borderRadius="none"
               marginBlockStart={1}
               type="number"
               step="0.001"
               {...rest}
               ref={ref} />
      </InputGroup>
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(MoneyFormInput);
